import React from "react";

interface ColumnProps {
  title: string;
  count: number;
  color: string;
  children: React.ReactNode;
}

const Column: React.FC<ColumnProps> = ({ title, count, color, children }) => {
  return (
    <div className="bg-white rounded-lg shadow-md">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center">
        <h3 className="font-semibold text-gray-700">{title}</h3>
        <span
          className={`${color} text-xs font-semibold px-2 py-1 rounded-full`}
        >
          {count}
        </span>
      </div>
      <div className="p-4 space-y-4">
        {children}
      </div>
    </div>
  );
};

export default Column;
